import { t } from 'i18next';
import { useEffect, useState } from 'react'
import { getSystemDateAndHourService } from '../services/accessHours';

const useGetDateAndHour = ({
    initialFormat = 'YYYY-MM-DD HH:mm:ss',
    enabled = true
} = {}) => {

    const [isFetchingSystemDate, setIsFetchingSystemDate] = useState(true);

    const [error, setError] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');

    const [systemDate, setSystemDate] = useState("");

    useEffect(() => {
        const getSystemDateAndHour = async (format) => {
            try {
                const response = await getSystemDateAndHourService(format);
                if (response.ok) {
                    setSystemDate(response.data.response);
                }
                setIsFetchingSystemDate(false);
                setError(false);
            } catch (e) {
                setError(true);
                setErrorMessage(t('ERROR_TRY_AGAIN'));
                console.log(e);
            }
        };
        if (enabled) {
            getSystemDateAndHour(initialFormat);
        }

    }, [initialFormat, enabled])

    return { isFetchingSystemDate, error, errorMessage, systemDate }
}

export default useGetDateAndHour